import { createBrowserHistory } from './historyServices';
export var getDefaultBrowserHistory = function (window) {
    if (!getDefaultBrowserHistory.history ||
        getDefaultBrowserHistory.window !== window) {
        getDefaultBrowserHistory.history = createBrowserHistory({ window: window });
        getDefaultBrowserHistory.window = window;
    }
    return getDefaultBrowserHistory.history;
};
